export default __webpack_public_path__ + "static/media/sounds/rct_accuracy_practice_correct.mp3";